import React, { ReactNode } from 'react';
import classNames from 'classnames';
import { notNil } from '../../core/helpers/is-nil';
import { ImageTransformType, ImageType } from '../../modules/image/constants';
import { Image } from '../../modules/image/image';
import styles from './page-header.module.scss';

type Props = {
  children: ReactNode;
  bgSrc?: string;
  variant?: 'start' | 'articleDetails';
};

export const PageHeader: React.FC<Props> = ({ children, bgSrc, variant = 'start' }) => {
  const hasPageHeaderBgImg = notNil(bgSrc);
  const isArticleDetailsVariant = variant === 'articleDetails';
  return (
    <div className={classNames(styles.root, { [styles.articleDetails]: isArticleDetailsVariant })}>
      <div className={styles.background}>
        {hasPageHeaderBgImg ? (
          <div className={styles.bgImgContainer}>
            <div className={styles.bgImg}>
              <Image
                baseSrc={bgSrc}
                className={styles.image}
                imageSizes={ImageTransformType.pageHeader}
                type={ImageType.fillContainer}
              />
            </div>
            {/* gradient should be rendered after img to be visible on top */}
            <div className={styles.gradient} />
          </div>
        ) : null}
      </div>
      <div className={styles.innerContainer}>
        <div className={classNames(styles.content, { [styles.articleDetails]: isArticleDetailsVariant })}>
          {children}
        </div>
      </div>
    </div>
  );
};
